import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'fr', flag: '\u{1F1EB}\u{1F1F7}', name: 'Français' },
  { code: 'en', flag: '\u{1F1EC}\u{1F1E7}', name: 'English' },
  { code: 'ar', flag: '\u{1F1F8}\u{1F1E6}', name: 'العربية' },
  { code: 'es', flag: '\u{1F1EA}\u{1F1F8}', name: 'Español' },
  { code: 'pt', flag: '\u{1F1F5}\u{1F1F9}', name: 'Português' },
  { code: 'tr', flag: '\u{1F1F9}\u{1F1F7}', name: 'Türkçe' },
  { code: 'de', flag: '\u{1F1E9}\u{1F1EA}', name: 'Deutsch' },
  { code: 'it', flag: '\u{1F1EE}\u{1F1F9}', name: 'Italiano' },
  { code: 'nl', flag: '\u{1F1F3}\u{1F1F1}', name: 'Nederlands' },
  { code: 'pl', flag: '\u{1F1F5}\u{1F1F1}', name: 'Polski' }
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const currentLang = languages.find(l => l.code === (i18n.language || '').substring(0, 2)) || languages[0];

  const changeLanguage = (code) => {
    i18n.changeLanguage(code);
    document.documentElement.dir = code === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = code;
    setOpen(false);
  };

  return (
    <div className="language-switcher" style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={() => setOpen(!open)}
        style={{
          background: 'transparent',
          border: '1px solid rgba(255,255,255,0.3)',
          borderRadius: '4px',
          color: 'inherit',
          padding: '4px 8px',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: '600'
        }}
      >
        {currentLang.flag}
      </button>
      {open && (
        <ul style={{
          position: 'absolute',
          top: '100%',
          right: 0,
          background: '#fff',
          border: '1px solid #ddd',
          borderRadius: '4px',
          listStyle: 'none',
          padding: '4px 0',
          margin: '4px 0 0 0',
          zIndex: 1000,
          minWidth: '120px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
        }}>
          {languages.map(lang => (
            <li key={lang.code}>
              <button
                onClick={() => changeLanguage(lang.code)}
                style={{
                  display: 'block',
                  width: '100%',
                  padding: '6px 12px',
                  border: 'none',
                  background: i18n.language === lang.code ? '#f0f0f0' : 'transparent',
                  cursor: 'pointer',
                  textAlign: 'left',
                  fontSize: '13px',
                  color: '#333'
                }}
              >
                <span style={{fontSize: '16px', marginRight: '6px'}}>{lang.flag}</span> {lang.name}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSwitcher;
